import { useLocation } from 'react-router-dom'
import { useTranslation } from '@/i18n'
import { useAppStore } from '@/store'
import { getSuggestionsForRoute } from './suggestedQuestionsMap'

/**
 * Opening view: route-aware prompt + numbered suggestion buttons.
 * Numbering is rendered from the index (presentation concern — RTL/ja
 * ordering differs), not baked into the translations.
 */
const SuggestedQuestions = () => {
  const { t } = useTranslation('help_agent')
  const location = useLocation()
  const sendHelpMessage = useAppStore((s) => s.sendHelpMessage)

  const entry = getSuggestionsForRoute(location.pathname)

  return (
    <div className="flex flex-col gap-2 p-4">
      <p className="mb-1 text-sm text-gray-700 dark:text-dark-text">{t(entry.promptKey)}</p>
      {entry.questionKeys.map((questionKey, index) => {
        const question = t(questionKey)
        return (
          <button
            key={questionKey}
            type="button"
            onClick={() => void sendHelpMessage(question, location.pathname)}
            className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-start text-sm text-gray-900 transition-colors hover:bg-gray-50 dark:border-dark-border dark:bg-dark-card dark:text-dark-text dark:hover:bg-dark-accent"
          >
            {index + 1}. {question}
          </button>
        )
      })}
      <button
        type="button"
        onClick={() => useAppStore.setState({ helpStage: 'chatting' })}
        className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-start text-sm text-gray-900 transition-colors hover:bg-gray-50 dark:border-dark-border dark:bg-dark-card dark:text-dark-text dark:hover:bg-dark-accent"
      >
        {entry.questionKeys.length + 1}. {t('suggestions.other')}
      </button>
    </div>
  )
}

export default SuggestedQuestions
